// @ts-nocheck
import * as React from "react";

const ClockFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4 11h-4a1 1 0 01-1-1V8a1 1 0 112 0v3h3a1 1 0 110 2z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(ClockFill);
